<template>
  <div class="tab-info">
    <i></i>
    <span>{{ txt }}</span>
  </div>
</template>
<script>
export default {
  props: {
    txt: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.tab-info {
  display: flex;
  align-items: center;

  i {
    display: block;
    width: 3px;
    height: 12px;
    background-color: #009cff;
    border-radius: 1px;
    margin: -2px 8px 0 0;
  }

  span {
    font-size: 13px;
    line-height: 13px;
    color: #262626;
    // font-weight: 500;
    font-weight: 500;
  }
}
</style>
